import type { TaskInputRequest } from '@gcv/shared';
import { useMutation } from '@tanstack/react-query';

import { TasksApi } from 'api/TasksApi';
import { useFiTaskCache } from 'tanstack-hooks/fi-tasks/tasks-cache';
import { FI_TASK_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useCreateTask() {
  const { userBankId } = useUser();
  const { addTask } = useFiTaskCache();
  const tasksApi = new TasksApi();

  const { mutateAsync: createTask, isPending: isCreateTaskPending } = useMutation({
    mutationKey: [FI_TASK_KEY],
    mutationFn: (payload: TaskInputRequest) => tasksApi.createNewTask(userBankId, payload),
    onSuccess: (task) => addTask(task),
    meta: {
      snackbarErrorMessage:
        'There was a problem creating the task. Please try again or contact our help desk!'
    }
  });

  return { createTask, isCreateTaskPending };
}
